module.exports = __webpack_public_path__ + "Frame399-68141c2b.webp";